(ns net.kestec.mhda-pilgrimage.admin.application-list
  (:require
    ["material-react-table" :refer [MaterialReactTable]]
    ["material-react-table/locales/de" :refer [MRT_Localization_DE]]
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Button" :default Button]
    ["@mui/material/Typography" :default Typography]
    ["@mui/icons-material/Info" :default InfoIcon]
    ["@mui/icons-material/Email" :default EmailIcon]
    ["@mui/icons-material/Phone" :default PhoneIcon]
    ["@mui/icons-material/CheckBox" :default CheckBox]
    ["@mui/icons-material/Done" :default DoneIcon]
    ["@mui/icons-material/Help" :default HelpIcon]
    ["@mui/icons-material/Download" :default DownloadIcon]
    ["@mui/icons-material/CheckBoxOutlineBlank" :default CheckBoxOutlineBlank]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as-alias admin-applications-events]
    [net.kestec.mhda-pilgrimage.admin.popup.application-status-popup :refer [application-status-popup]]
    [net.kestec.mhda-pilgrimage.admin.popup.application-payment-popup :refer [application-payment-popup]]
    [net.kestec.mhda-pilgrimage.admin.popup.application-fix-popup :refer [application-fix-popup]]
    [net.kestec.mhda-pilgrimage.util.date :as h-date]
    ["react" :as react]
    [clojure.edn :as edn]
    [goog.string :as gstring]
    [clojure.string :as str]
    [goog.string.format]
    [oops.core :as oo]
    [re-frame.core :as rf]
    [reagent.core :as r]))

(rf/reg-event-fx
  ::set-mode
  (fn [{db :db} [_ t]]
    {:db (-> db
             (assoc ::mode t))}))
(rf/reg-event-fx
  ::set-show-attempts
  (fn [{db :db} [_ t]]
    {:db (-> db
             (assoc ::show-attempts t))}))

(defn link-cell [icon link-prefix]
  (fn [d]
    (let [data (oo/oget d :renderedCellValue)]
      (when (> (count (str data)) 0)
        (r/as-element
          [:a {:href  (str link-prefix data)
               :style {:textAlign "center"}}
           [:> icon] [:br]])))))

(defn validated-cell [d]
  (let [valid? (oo/oget d :renderedCellValue)
        hint (oo/oget d :row :original :validate_hint)]
    (println valid? "-" hint)
    (r/as-element
      (if valid?
        [:> DoneIcon {:style {:color "darkgreen"}}]
        [:div
         [:> HelpIcon {:style {:color "darkred"}}] [:br]
         [:p {:style {:fontSize "9px"}} (str hint)]
         ]
        ))))

(defn date-cell [d]
  (h-date/format-timeShort (oo/oget d :renderedCellValue)))

(defn status-popup-cell [d]
  (let [status (oo/oget d :renderedCellValue)
        id (oo/oget d :row :original :id)
        color "lightgrey"]
    (r/as-element
      [:div {:onClick (fn [_]
                        (println "open-popup-cell: " id)
                        (rf/dispatch [::admin-applications-events/set-status-popup-application id]))

             :style   {:width           "80px"
                       :height          "30px"
                       :backgroundColor color
                       :borderRadius    "6px"
                       :textAlign       "center"
                       :border          (str "2px solid " color)
                       }}
       (str status)]
      )))

(defn place_state-popup-cell [d]
  (let [status (oo/oget d :renderedCellValue)
        statusColor (case (str status)
                      "Fixstarter" "#065a06"
                      "Warteliste" "#787808"
                      "Abgelehnt" "red"
                      "Unbekannt" "#2a2a63"
                      )
        id (oo/oget d :row :original :id)]
    (r/as-element
      [:> Button
       {:style   {:backgroundColor statusColor :color "white"}
        :onClick (fn [_]
                   ;(println "open-popup-cell: " id)
                   (rf/dispatch [::admin-applications-events/set-fix-popup-application id]))}
       status]
      )))

(defn paid-popup-cell [d]
  (let [groups @(rf/subscribe [::db/get ::db/me :enriched-session :groups])
        sum (oo/oget d :renderedCellValue)
        id (oo/oget d :row :original :id)
        color (if (and sum (pos? (float sum))) "#cdffcd" "grey")]
    (r/as-element
      [:div {:onClick (fn [_]
                        (println "open-popup-cell: " id)
                        (when (or (some #(= % "/admin_FINANZ") groups)
                                  (some #(= % "/pilgrimage_admin") groups))
                          (rf/dispatch [::admin-applications-events/set-payment-popup-application id])))

             :style   {:width           "80px"
                       :height          "30px"
                       :backgroundColor color
                       :borderRadius    "6px"
                       :textAlign       "center"
                       :border          (str "2px solid " color)
                       }}
       (if sum (gstring/format "%.2f" sum) "-")]
      )))

(def COLUMNS
  [

   {:header              "ID"
    :id                  "id"
    :accessorKey         "id"
    :size                60
    :grow                3
    :enableColumnActions false
    :Cell                (link-cell InfoIcon "/admin/application/")}


   {:header              "Abgeschlossen"
    :id                  "validated"
    :size                120
    :grow                10
    :enableColumnActions false
    :accessorKey         "validated"
    :Cell                validated-cell}

   {:header              "Daten geprüft"
    :id                  "application_checked"
    :size                60
    :grow                10
    :enableColumnActions false
    :accessorKey         "application_checked"
    }

   {:header              "Einzahlung"
    :id                  "paid_sum"
    :size                120
    :grow                10
    :enableColumnActions false
    :accessorKey         "paid_sum"
    :Cell                paid-popup-cell}

   {:header              "Status"
    :id                  "place_state"
    :size                120
    :grow                10
    :enableColumnActions false
    :accessorKey         "place_state"
    :Cell                place_state-popup-cell}

   {:header              "Ersteller"
    :id                  "applicant_name"
    :size                120
    :grow                10
    :enableColumnActions false
    :accessorKey         "applicant_name"}

   {:header              "Erstellt"
    :id                  "created"
    :size                80
    :grow                10
    :enableColumnActions false
    :accessorKey         "created"
    :Cell                date-cell}


   {:header              "Vorname"
    :id                  "given_name"
    :size                120
    :grow                10
    :enableColumnActions false
    :accessorKey         "given_name"}

   {:header              "Nachname"
    :id                  "family_name"
    :size                120
    :grow                10
    :enableColumnActions false
    :accessorKey         "family_name"}


   {:header              "Bereich"
    :id                  "selected_division"
    :size                120
    :grow                10
    :enableColumnActions false
    :accessorKey         "selected_division"
    :Cell                status-popup-cell
    }

   {:header              "Typ"
    :id                  "mhda_type"
    :size                120
    :grow                10
    :enableColumnActions false
    :accessorKey         "mhda_type"
    :Cell                status-popup-cell
    }

   {:header              "Attest Dokumente"
    :id                  "med_documents_cnt"
    :size                60
    :grow                10
    :enableColumnActions false
    :accessorKey         "med_documents_cnt"
    }
   {:header              "Pflege Dokumente"
    :id                  "nurse_documents_cnt"
    :size                60
    :grow                10
    :enableColumnActions false
    :accessorKey         "nurse_documents_cnt"
    }
   {:header              "Medizinisch geprüft"
    :id                  "med_checked"
    :size                60
    :grow                10
    :enableColumnActions false
    :accessorKey         "med_checked"
    }
   {:header              "Geburtsdatum"
    :id                  "birthdate"
    :size                60
    :grow                10
    :enableColumnActions false
    :accessorKey         "birthdate"
    }

   {:header              "Einzelzimmer bestellt"
    :id                  "single_room_booked"
    :size                60
    :grow                10
    :enableColumnActions false
    :accessorKey         "single_room_booked"
    }

   {:header              "Versicherung bestellt"
    :id                  "insurance_booked"
    :size                60
    :grow                10
    :enableColumnActions false
    :accessorKey         "insurance_booked"
    }

   {:header              "Email"
    :id                  "email"
    :accessorKey         "email"
    :size                60
    :grow                3
    :enableColumnActions false
    :Cell                (link-cell EmailIcon "mailto:")}

   {:header              "Tel"
    :id                  "phone"
    :accessorKey         "phone"
    :size                60
    :grow                3
    :enableColumnActions false
    :Cell                (link-cell PhoneIcon "phone:")}])

(defn table-state [{:strs [cf cv d gf scf sgf s p]}]
  {"cv"  (merge {"nurse_documents_cnt" false
                 "med_documents_cnt"   false
                 "application_checked" false
                 "med_checked"         false
                 "single_room_booked"  false
                 "insurance_booked"    false
                 "birthdate"           false}
                cv)
   "cf"  cf
   "p"   (merge {"pageIndex" 0
                 "pageSize"  10}
                p)
   "gf"  gf
   "scf" scf
   "sgf" sgf
   "s"   (or s [])})

(rf/reg-sub
  ::table-state
  (fn [{:as db
        {:keys [query-params]}
        ::route/route}
       _]
    (let [{:as   sub-params
           :strs [cf cv gf scf sgf s p]}
          (table-state
            (try (edn/read-string (:cts query-params))
                 (catch :default _ {})))]
      {:columnVisibility cv
       :pagination       p
       :columnFilter     cf
       :globalFilter     gf
       :showColumnFilter scf
       :showGlobalFilter sgf
       :sorting          s})))

(rf/reg-event-fx
  ::table-state
  (fn [{:keys [db]} [_ prop fvalue]]
    (let [old-cts (table-state
                    (try (-> db ::route/route :query-params :cts edn/read-string)
                         (catch :default _ {})))
          v (if (fn? fvalue)
              (fvalue (clj->js (get old-cts prop)))
              fvalue)
          cts (assoc old-cts
                prop (js->clj v))]
      {:dispatch (when (not= old-cts cts)
                   [::route/push
                    (:name (:data (::route/route db)))
                    :path-params (:path-params (::route/route db))
                    :query-params (assoc (:query-params (::route/route db))
                                    :cts (pr-str cts))])})))


(defn action-head [list-mode show-attempts]
  [:<>
   [:div {:style {:padding-left "10px"}}
    [:span {:style {:font-size "20px" :font-weight "bold" :padding "5px 50px 0 0"}} "Antragsliste"]
    [:> Button {:sx        {:margin-left "25px"}
                :startIcon (r/as-element (if show-attempts [:> CheckBoxOutlineBlank] [:> CheckBox]))
                :onClick   #(rf/dispatch [::set-show-attempts (not show-attempts)])}
     "nur abgeschlossen"]
    [:> Button {:sx        {:margin-left "25px"}
                :startIcon (r/as-element [:> DownloadIcon])
                :href      (str "/api/pilgrimage/" @(rf/subscribe [::db/get ::db/me :pilgrimage-id]) "/application-xls")}
     "XLS"]
    ]])

(defn get-list [_type]
  (let [list-mode (or @(rf/subscribe [::db/get ::mode]) :mine)
        show-attempts @(rf/subscribe [::db/get ::show-attempts])
        list-data (mapv (fn [e] {:id                  (str (:id e))
                                 :applicant_name      (str (:applicant_name e))
                                 :application_checked (if (:application_checked e) "OK" "--")
                                 :med_checked         (if (:med_checked e) "OK" "--")
                                 :given_name          (str (:shown_first_name e) (if (= (:shown_first_name e) (:given_name e)) "" (str " (" (:given_name e) ")")))
                                 :family_name         (str (:shown_last_name e))
                                 :mhda_type           (str (or (:mhda_type e) "PI"))
                                 :selected_division   (str (:selected_division e))
                                 :med_documents_cnt   (count (:med_documents e))
                                 :nurse_documents_cnt (count (:nurse_documents e))
                                 :insurance_booked    (if (:insurance_booked e) "J" "N")
                                 :single_room_booked  (if (:single_room_booked e) "J" "N")
                                 :birthdate           (first (str/split (:birthdate e) #"T"))
                                 :place_state         (case (:place_state e)
                                                        "FIX" "Fixstarter"
                                                        "WAIT" "Warteliste"
                                                        "OFF" "Abgelehnt"
                                                        "Unbekannt")
                                 :email               (str (:email e))
                                 :paid_sum            (:paid_sum e)
                                 :created             (:created e)
                                 :phone               (str (:phone e))
                                 :validated           (:validated e)
                                 :validate_hint       (:validate_hint e)})
                        (filter (fn [e]
                                  (or show-attempts (:validated e))
                                  ) @(rf/subscribe [::db/get ::admin-applications-events/admin-applications])))]
    (js/console.log "list-mode" list-mode " list-data" list-data)
    [:div {:style {:width "100%"}}
     [:> MaterialReactTable
      {:columns                       COLUMNS
       :state                         @(rf/subscribe [::table-state])
       :localization                  MRT_Localization_DE
       :density                       "compact"
       :layoutMode                    "grid"
       :autoResetPageIndex            false
       :enableRowActions              false
       :enableActions                 false
       :defaultColumn                 {:width "auto"}
       :defaultDisplayColumn          {:enableKeyboardShortcuts false
                                       :enableColumnActions     false
                                       :enableColumnFilters     false
                                       :enableSorting           false}
       :muiTableBodyRowProps          {:hover false}
       :renderTopToolbarCustomActions (fn [table] (r/as-element [action-head (if (= _type :waivers) :waivers list-mode) show-attempts]))
       :onColumnFilterChange          #(rf/dispatch [::table-state "cf" %])
       :onColumnVisibilityChange      #(rf/dispatch [::table-state "cv" %])
       :onDensityChange               #(rf/dispatch [::table-state "d" %])
       :onGlobalFilterChange          #(rf/dispatch [::table-state "gf" %])
       :onShowColumnFilterChange      #(rf/dispatch [::table-state "scf" %])
       :onShowGlobalFilterChange      #(rf/dispatch [::table-state "sgf" %])
       :onSortingChange               #(rf/dispatch [::table-state "s" %])
       :onPaginationChange            #(rf/dispatch [::table-state "p" %])
       :data                          list-data}]]))




(defn main []
  [base-page
   [:> Paper {:sx {:padding "7px"}}
    [:br]
    [application-status-popup]
    [application-payment-popup]
    [application-fix-popup]
    [get-list :waivers]]])



